import { Directive, ElementRef, effect, inject, input, signal } from '@angular/core';

/** Auto-scrolls listbox to the pre-selected item when panel opens */
@Directive({
  selector: '[lxListboxScrollToSelectedItem]',
  standalone: true,
})
export class ListboxScrollToSelectedItemDirective {
  scrollWhenVisible = input<boolean | undefined>();
  scrollBehavior = input<ScrollBehavior>('auto');
  scrollBlock = input<ScrollLogicalPosition>('end');

  private readonly elementRef = inject(ElementRef);
  private readonly hasScrolledOnce = signal(false);

  constructor() {
    effect(() => {
      if (this.scrollWhenVisible() && !this.hasScrolledOnce()) {
        setTimeout(() => this.performScroll());
      }
    });
  }

  /** Scrolls to the selected item using PrimeNG's .p-highlight class */
  private performScroll(): boolean {
    const containerElement = this.elementRef.nativeElement;
    const listboxContainer = containerElement.querySelector('.p-listbox-list-wrapper');
    if (!listboxContainer) {
      return false;
    }

    const selectedElement = listboxContainer.querySelector('.p-highlight') as HTMLElement;
    if (selectedElement) {
      selectedElement.scrollIntoView({
        behavior: this.scrollBehavior(),
        block: this.scrollBlock(),
      });
      this.hasScrolledOnce.set(true);
      return true;
    }

    return false;
  }
}
